import moment from "moment";
import * as React from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import { callApi } from "../../utils/api";
import {
  ADMIN_ROLE,
  EXECITUVE_ROLE,
  FRONTOFFICE_ROLE,
  MANAGER_ROLE,
} from "../../utils/role";
import AssignBankUser from "./AssignBankUser";
import FileSearchModal from "./FileSearchModal";
import { hasPageAccess } from "../../utils/pagePermissionService";
import Queuefilesexceldownload from "../dashboard/Queuefilesexceldownload";
interface AllProps {
  history: any;
}
declare var $: any;

class ManageUnassignedFile extends React.Component<AllProps> {
  state = {
    selectVal: false,
    outreason: "",
    files: [],
    fileToBeAssigned: 0,
    isFileRefresh: false,
    loginfiles: [],
    waitingfiles: [],
    emergentFile: [],
    getfileforDownload: [],
    aPlusFile: [],
    autoAssign: [
      {
        "id": "1",
        "module_name": "Auto Assign",
        "status": true
      }
    ],
    isLoading: false,
    pageDynamic: [],
    commonSearch: "",
    isGradeSummaryExpanded: false,
  };
  interval: NodeJS.Timeout | null = null;

  async componentDidMount() {
    this.getOutTime();
    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.ouTime();
    }
    this.state.autoAssign.find(
      (data: any) => {
        if (data.module_name === "Auto Assign" && data.status == false) {
          this.getFiles();
        } else {
          this.getFilesqueue();
        }
      });
    this.getPageDynamicData();
  }

  componentWillUnmount() { }

  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ pageDynamic: result.responseJson.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getAutoAssignStatus = () => {
    callApi("GET", "module_option_select.php", "")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ autoAssign: result.responseJson.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFilesqueue = () => {
    this.setState({ isFileRefresh: false });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const user_grade = user ? JSON.parse(user)["user_grade"] : "";
    const my_branchs = user ? JSON.parse(user)["my_branchs"] : "";
    const roleType = user ? JSON.parse(user)["roleType"] : "";
    let queue: any;
    if (this.state.autoAssign && this.state.autoAssign.find((data: any) => data.module_name == "Auto Assign" && data.status == true)) {
      queue = 1;
    } else {
      queue = 0;
    }
    let req = {
      status: 0, userId: userId, queue: queue, user_grade: user_grade, my_branchs: my_branchs
    }
    callApi("POST", "get_by_status.php", req)
      .then((res) => res.data)
      .then((response) => {
        const files = response.data;
        const currentDate: any = new Date();
        const newFilesMoreThan20: any = [];
        const newFilesLessThan20: any = [];
        let emergentFile: any[] = [];
        let aPlusFile: any[] = [];

        files.forEach((file: any) => {
          if (file.file_grade == "E" && ["8"].includes(file.file_status) && roleType == "7") {
            emergentFile.push(file);
          } else {
            if (file.file_grade == "E" && ["0", "1", "2", "8"].includes(file.file_status) && roleType != "7") {
              emergentFile.push(file);
            }
          }

          if (file.file_grade == "A+") {
            aPlusFile.push(file);
          }

          const fileDateTime = file.date_time.split("/");
          const fileDate = fileDateTime[0];
          const fileTime = fileDateTime[1];
          const [fileDay, fileMonth, fileYear] = fileDate.split("-");
          const [fileHour, fileMinute] = fileTime.split(":");
          const fileDateObject: any = new Date(
            parseInt(fileYear, 10),
            parseInt(fileMonth, 10) - 1,
            parseInt(fileDay, 10),
            parseInt(fileHour, 10),
            parseInt(fileMinute, 10)
          );
          const timeDifference = Math.floor(
            (currentDate - fileDateObject) / (1000 * 60)
          );
          if (timeDifference >= 20 && file.file_status != "0" && roleType == "7" && file.file_grade != "E" && file.file_grade != "A+") {
            newFilesMoreThan20.push(file);
          } else if (timeDifference >= 20 && roleType != "7" && file.file_grade != "E" && file.file_grade != "A+") {
            newFilesMoreThan20.push(file);
          } else {
            if (timeDifference <= 20 && file.file_status != "0" && roleType == "7" && file.file_grade != "E" && file.file_grade != "A+") {
              newFilesLessThan20.push(file);
            } else if (timeDifference <= 20 && roleType != "7" && file.file_grade != "E" && file.file_grade != "A+") {
              newFilesLessThan20.push(file);
            }
          }
        });

        const normalize = (arr: any[], startIdx = 1) => {
          arr.forEach((file, index) => {
            Object.keys(file).forEach((fileKey) => {
              file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== "string" ? String(file[fileKey]) : file[fileKey];
            });
            file.index = index + startIdx;
          });
        };
        normalize(newFilesLessThan20);
        normalize(newFilesMoreThan20);
        normalize(emergentFile);
        normalize(aPlusFile);

        this.setState({ waitingfiles: newFilesMoreThan20, isFileRefresh: true, emergentFile, aPlusFile, getfileforDownload: files });
        this.setState({ loginfiles: newFilesLessThan20, isFileRefresh: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  previousPop = () => {
    $("#out_reason").modal("show");
    $("#another-reason").modal("hide");
  };

  BacktoFile = () => {
    $("#out_reason").modal("hide");
    const fileid1: any = localStorage.getItem("currentfileId");
    this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
  }

  getOutTime = () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime))
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    } else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
  }

  ouTime = () => {
    if (localStorage.getItem("currentfileId")) {
      $("#out_reason").modal("show");
    }
  };

  outimeGet = () => {
    this.setState({ isLoading: true });
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    const outtime: any = localStorage.getItem("outtimeGet");
    const outdate: any = localStorage.getItem("OutDateGet");
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    if (this.state.outreason == "") {
      this.setState({ selectVal: true });
    } else {
      let obj = {
        file_id: JSON.parse(fileid1),
        user_id: JSON.parse(userid1),
        in_reason: JSON.parse(inreason),
        out_reason: this.state.outreason,
        intime: JSON.parse(intime),
        outtime: JSON.parse(outtime),
        insert_date: JSON.parse(outdate),
        "insert_id": insertId
      };
      callApi("POST", "process_eod_insert.php", obj)
        .then((res) => res.data)
        .then((response) => {
          this.setState({ isLoading: false });
          localStorage.removeItem("in_reason");
          localStorage.removeItem("outreason");
          localStorage.removeItem("IntimeGet");
          localStorage.removeItem("OutDateGet");
          $("#out_reason").modal("hide");
          $("#another-reason").modal("hide");
          ToastsStore.success("Your Reason Saved Successfully");
          let process_officerId: any = localStorage.getItem("process_office_id");
          let process_officer_id = JSON.parse(process_officerId);
          const userid1: any = localStorage.getItem("user1");
          let user_id = JSON.parse(userid1);
          const take_file: any = localStorage.getItem("takenfile_id");
          const query_status: any = localStorage.getItem("query_raised_status");
          const file_completed = localStorage.getItem("file_completed_status");
          if (process_officer_id == user_id && take_file != "" && take_file === fileid1 && query_status == "false" && file_completed == "false") {
            this.fileout(fileid1);
          } else {
            localStorage.removeItem('currentfileId');
            localStorage.removeItem("query_raised_status");
            localStorage.removeItem("file_completed_status");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          console.log(err);
          ToastsStore.error("Your Reason Not Stored");
        });
    }
  };

  fileout = (fileid1) => {
    let fileId = JSON.parse(fileid1);
    const loginuser: any = localStorage.getItem("user1");
    let req = { id: fileId, reason: "File Out", created_by: JSON.parse(loginuser) }
    callApi("POST", "time_update.php", req)
      .then(res => res.data)
      .then(response => {
        localStorage.removeItem('currentfileId');
        localStorage.removeItem("query_raised_status");
        localStorage.removeItem("file_completed_status");
      });
  }

  onchangeReason = (e: any) => {
    if (e.target.value == "Other") {
      this.setState({ in_reason: "", selectVal: false });
      $("#out_reason").modal("hide");
      $("#another-reason").modal("show");
    } else if (e.target.value == "select") {
      this.setState({ setResponse: false });
    } else {
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };

  onchange = (e: any) => {
    this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
  };

  getFiles = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "get_by_status.php", { status: 0, userId })
      .then((res) => res.data)
      .then((response) => {
        const files = response.data;
        if (files && files.length > 0) {
          files.forEach((file, index) => {
            Object.keys(file).forEach((fileKey) => {
              file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== "string" ? String(file[fileKey]) : file[fileKey];
            });
            file.index = index + 1;
          });
        }
        this.setState({ files, isFileRefresh: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  assignFile = (modal: any) => {
    this.setState({ fileToBeAssigned: modal.id });
  };

  assignPickFile = (modal: any) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = { id: modal.id, assigned_to: userId };
    callApi("POST", "self_assign.php", obj)
      .then((response) => response.data)
      .then((res) => {
        ToastsStore.success("File Assigned Successfully");
        setTimeout(() => {
          this.props.history.push("/file-dashboard/" + modal.id);
        }, 2000);
      });
  };

  emergentFile = (modal: any) => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = { fileid: modal.id, emergent_status: 1, userid: userId };
    callApi("POST", "emergent_update.php", obj)
      .then((response) => response.data)
      .then((res) => {
        if (typeof res?.remaining_quota !== "undefined") {
          localStorage.setItem("emergent_quota", String(res.remaining_quota));
        }
        if (res.statusCode == 200) {
          ToastsStore.success(res.message);
          this.getFilesqueue();
        } else {
          ToastsStore.error(res.message);
        }
      });
  };

  goToFileDashboard = (id) => {
    const url = "/unassigned-file";
    localStorage.setItem("url", url);
    let obj = { id: id };
    localStorage.setItem("thisPopup", JSON.stringify(obj));
    localStorage.setItem("currentfileId", JSON.stringify(id));
    this.props.history.push("/file-dashboard/" + id);
  };

  fileSearch = (modal) => {
    this.setState({ isFileRefresh: false });
    callApi("POST", "file_search.php", modal)
      .then((res) => res.data)
      .then((response) => {
        const files: any = [];
        if (response.data && response.data.length > 0) {
          response.data.forEach((file: any, index: number) => {
            Object.keys(file).forEach((fileKey) => {
              file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== "string" ? String(file[fileKey]) : file[fileKey];
            });
            file.index = index + 1;
            files.push(file);
          });
        }
        this.setState({ files, isFileRefresh: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  applyCommonSearch = (fileArray: any[]): any[] => {
    const term = (this.state.commonSearch || "").toLowerCase().trim();
    if (!term) return fileArray;
    return fileArray.filter((file: any) =>
      Object.values(file).some((val) => val && String(val).toLowerCase().includes(term))
    );
  };

  // ── NEW: Compute grade breakdown counts for a file array ──
  getGradeCounts = (fileArray: any[]) => {
    const counts: Record<string, number> = {};
    fileArray.forEach((file: any) => {
      const grade = file.file_grade || "Unknown";
      counts[grade] = (counts[grade] || 0) + 1;
    });
    return counts;
  };

  // ── NEW: Compute new vs query split ──
  getNewQueryCounts = (fileArray: any[]) => {
    // file_status "8" = query raised, others = new
    let newCount = 0;
    let queryCount = 0;
    fileArray.forEach((file: any) => {
      if (file.file_status === "8") queryCount++;
      else newCount++;
    });
    return { newCount, queryCount };
  };

  // ── NEW: Render grade summary as compact table with both New and Query breakdowns ──
  renderGradeSummary = () => {
    const { aPlusFile, waitingfiles, loginfiles, emergentFile } = this.state;

    // Helper to get grade breakdown string
    const getGradeString = (files) => {
      const counts = this.getGradeCounts(files);
      const gradeOrder = ["E", "A+", "A1", "A", "B", "C"];

      const parts: any = [];
      gradeOrder.forEach((grade: any) => {
        if (counts[grade]) {
          parts.push(`${grade}:${counts[grade]}`);
        }
      });

      return parts.length > 0 ? parts.join(' ') : '—';
    };

    return (
      <div style={{
        background: '#ffffff',
        borderRadius: '12px',
        padding: '20px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        color: '#1e293b',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e2e8f0'
      }}>
        {/* Header */}
        <div
          onClick={() => this.setState((prev: any) => ({ isGradeSummaryExpanded: !prev.isGradeSummaryExpanded }))}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: this.state.isGradeSummaryExpanded ? '20px' : '0',
            paddingBottom: this.state.isGradeSummaryExpanded ? '12px' : '0',
            borderBottom: this.state.isGradeSummaryExpanded ? '1px solid #e2e8f0' : 'none',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '20px', fontWeight: 600, color: '#0f172a' }}>
              File Grade Summary
            </span>
            <span style={{ fontSize: '28px', fontWeight: 700, color: '#2563eb', lineHeight: 1 }}>
              - {aPlusFile.length + waitingfiles.length + loginfiles.length + emergentFile.length}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div style={{ display: 'flex', gap: '24px', color: '#64748b', fontSize: '14px' }}>
              <span>A+ <strong style={{ color: '#0f172a', marginLeft: '6px', fontSize: '16px' }}>{aPlusFile.length}</strong></span>
              <span>Wait <strong style={{ color: '#0f172a', marginLeft: '6px', fontSize: '16px' }}>{waitingfiles.length}</strong></span>
              <span>New <strong style={{ color: '#0f172a', marginLeft: '6px', fontSize: '16px' }}>{loginfiles.length}</strong></span>
              <span>Emerg <strong style={{ color: '#0f172a', marginLeft: '6px', fontSize: '16px' }}>{emergentFile.length}</strong></span>
            </div>
            <span style={{ fontSize: '18px', color: '#64748b', transition: 'transform 0.2s', display: 'inline-block', transform: this.state.isGradeSummaryExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              ▼
            </span>
          </div>
        </div>

        {/* Main Table — only show when expanded */}
        {this.state.isGradeSummaryExpanded && (
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '20px'
          }}>
            <thead>
              <tr style={{
                color: '#64748b',
                fontSize: '13px',
                fontWeight: 600,
                borderBottom: '2px solid #e2e8f0'
              }}>
                <th style={{ textAlign: 'center', padding: '0 0 12px 0' }}>Category</th>
                <th style={{ textAlign: 'center', padding: '0 0 12px 0' }}>New</th>
                <th style={{ textAlign: 'center', padding: '0 0 12px 0' }}>Query</th>
                <th style={{ textAlign: 'center', padding: '0 0 12px 0' }}>Grade Breakdown (New → Query)</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  label: 'A+ Files',
                  files: aPlusFile
                },
                {
                  label: 'Waiting 20+',
                  files: waitingfiles
                },
                {
                  label: 'New Files',
                  files: loginfiles
                },
                {
                  label: 'Emergent',
                  files: emergentFile
                }
              ].map((item, idx) => {
                const newFiles = item.files.filter((f: any) => f.file_status !== '8');
                const queryFiles = item.files.filter((f: any) => f.file_status === '8');

                // Get grade strings for both
                const newGradeStr = getGradeString(newFiles);
                const queryGradeStr = getGradeString(queryFiles);

                return (
                  <tr key={idx} style={{
                    borderBottom: idx < 3 ? '1px solid #e2e8f0' : 'none'
                  }}>
                    <td style={{
                      textAlign: 'center',
                      padding: '14px 0',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#334155'
                    }}>
                      {item.label}
                    </td>
                    <td style={{
                      textAlign: 'center',
                      padding: '14px 0',
                      fontWeight: 600,
                      fontSize: '16px',
                      color: newFiles.length ? '#0f172a' : '#94a3b8'
                    }}>
                      {newFiles.length}
                    </td>
                    <td style={{
                      textAlign: 'center',
                      padding: '14px 0',
                      fontWeight: 600,
                      fontSize: '16px',
                      color: queryFiles.length ? '#0f172a' : '#94a3b8'
                    }}>
                      {queryFiles.length}
                    </td>
                    <td style={{
                      textAlign: 'center',
                      padding: '14px 0 14px 12px',
                      color: '#475569',
                      fontSize: '13px',
                      fontFamily: 'monospace'
                    }}>
                      <div style={{ marginBottom: queryFiles.length ? '4px' : '0' }}>
                        <span style={{ color: '#059669', marginRight: '4px', fontWeight: 500 }}>New -</span> {newGradeStr}
                      </div>
                      {queryFiles.length > 0 && (
                        <div>
                          <span style={{ color: '#b91c1c', marginRight: '4px', fontWeight: 500 }}>Query -</span> {queryGradeStr}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  render() {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const roleType = user ? JSON.parse(user)["roleType"] : "";
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    const emergent_quota: any = localStorage.getItem("emergent_quota");
    const isExpressEnableToUser = ["401", "565", "284", "590", "572", "432", "242"].includes(userId);

    const columns = [
      {
        header: "ID",
        key: "id",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.index}</td>
        ),
      },
      {
        header: "Actions",
        td: (file) => {
          return (
            <div className="btn-group mb-2">
              {this.state.autoAssign && this.state.autoAssign.find(
                (data: any) => data.module_name === "Auto Assign" && data.status) ?
                <>
                  {file.emergent_status == 1 && emergent_quota > 0 ? (<>
                    {this.state.pageDynamic.map((page: any, index: any) => {
                      if (page.page_name === "Emergent Button" && page.status == true) {
                        return (
                          <button key={index} type="button" className="btn btn-sm"
                            style={{ marginRight: 10, background: "rgb(227 172 36)", padding: "0px" }} disabled>
                            Emergent File
                          </button>
                        );
                      }
                    })}
                  </>) : (<>
                    {emergent_quota > 0 && this.state.pageDynamic.map((page: any, index: any) => {
                      if (page.page_name === "Emergent Button" && page.status == true) {
                        return (
                          <button key={index} type="button" className="btn btn-primary btn-sm"
                            style={{ marginRight: 10, padding: "0px" }} onClick={() => this.emergentFile(file)}>
                            Emergent File
                          </button>
                        );
                      }
                    })}
                  </>)}
                </> : ""
              }
              {this.state.autoAssign && this.state.autoAssign.find(
                (data: any) => data.module_name === "Auto Assign" && data.status) ?
                <>
                  {role_label == "ADMIN" && ["1", "173"].includes(userId) ?
                    <button type="button" className="btn btn-primary btn-sm"
                      onClick={() => this.assignFile(file)} data-toggle="modal" data-target="#assign-modal">
                      Assign To
                    </button> : ""}
                </> : <>
                  {[ADMIN_ROLE, FRONTOFFICE_ROLE, MANAGER_ROLE].includes(role_id) && (
                    <button type="button" className="btn btn-primary btn-sm"
                      onClick={() => this.assignFile(file)} data-toggle="modal" data-target="#assign-modal">
                      Assign To
                    </button>
                  )}
                </>}
            </div>
          );
        },
      },
      {
        header: "File ID",
        key: "file_id",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>
            {file.file_id}
            {file.is_marked_file && <span style={{ color: "green", fontWeight: 600 }}>(M)</span>}
          </td>
        ),
      },
      {
        header: "Bank Name",
        key: "bank_name",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>
            {file.bank_name}{" "}{file.product_name ? <>({file.product_name})</> : ""}
          </td>
        ),
      },
      {
        header: "Property Owner Name",
        key: "property_ownername",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.property_ownername}</td>
        ),
      },
      ...(this.state.pageDynamic?.find((page: any) =>
        page.page_name === "Queue File Location Column" && page.status
      ) ? [{
        header: "File Location",
        key: "file_location",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.file_location}</td>
        ),
      }] : []),
      {
        header: "Law Hands Branch",
        key: "law_hand_branch",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.law_hand_branch}</td>
        ),
      },
      {
        header: "Login By",
        key: "login_by",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.login_by}</td>
        ),
      },
      {
        header: "Updated Date",
        key: "updated_time",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.updated_time}</td>
        ),
      },
    ];

    const emergentColumns = [
      columns[0], // ID
      columns[2], // File ID
      columns[3], // Bank Name
      columns[4], // Property Owner Name
      ...(this.state.pageDynamic?.find((page: any) =>
        page.page_name === "Queue File Location Column" && page.status
      ) ? [columns[5]] : []), // File Location
      {
        header: "Law Hands Branch",
        key: "law_hand_branch",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.law_hand_branch}</td>
        ),
      },
      {
        header: "Emergent Init By",
        key: "emergent_by",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>{file.emergent_by || "-"}</td>
        ),
      },
      {
        header: "Updated Date",
        key: "emergent_init_dt",
        td: (file) => (
          <td onClick={() => this.goToFileDashboard(file.id)}>
            {file.emergent_init_dt
              ? moment(file.emergent_init_dt).isValid()
                ? moment(file.emergent_init_dt).format("DD-MM-YYYY HH:mm")
                : file.emergent_init_dt
              : "-"}
          </td>
        ),
      },
    ];

    const { selectVal } = this.state;
    const emergentquota: any = localStorage.getItem("emergent_quota");
    const COLOR = emergentquota > 5 ? 'green' : 'red';

    const filteredAPlusFile = this.applyCommonSearch(this.state.aPlusFile);
    const filteredWaitingData = this.applyCommonSearch(this.state.waitingfiles);
    const filteredLoginData = this.applyCommonSearch(this.state.loginfiles);
    const filteredEmergentFile = this.applyCommonSearch(this.state.emergentFile);
    const filteredData = this.applyCommonSearch(this.state.files);

    const term = (this.state.commonSearch || "").toLowerCase().trim();
    const matchInfo = term ? [
      { label: "A+ Grade Files", count: filteredAPlusFile.length },
      { label: "Waiting Files 20+ Mins", count: filteredWaitingData.length },
      { label: "New Files", count: filteredLoginData.length },
      { label: "Emergent Files", count: filteredEmergentFile.length },
    ].filter(m => m.count > 0) : [];

    return (
      <section className="pcoded-main-container">
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <div style={{ display: "flex" }}>
                            <h5 className="file-status-header">
                              {this.state.autoAssign && this.state.autoAssign.find(
                                (data: any) => data.module_name === "Auto Assign" && data.status) ?
                                <>Queue Files Manage</> : <>Unassigned Files Manage</>}
                            </h5>

                            {this.state.pageDynamic.map((page: any, index: any) => {
                              if (page.page_name === "Emergent Button" && page.status == true) {
                                return (
                                  <div key={index} style={{ display: "flex", marginLeft: "2%", marginTop: "2% " }}>
                                    <p>Balance Emergent Quota - </p>
                                    <span style={{ background: COLOR, color: "white", borderRadius: "50%", padding: "3px 7px", height: "23px" }}>
                                      {emergentquota}
                                    </span>
                                  </div>
                                );
                              }
                            })}
                          </div>
                          <div className="file-search-button"></div>
                        </div>

                        {/* OUT REASON MODAL */}
                        <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                          <div className="modal-dialog">
                            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                              <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                              </div>
                              <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select className="custom-select" name="outreason" value={this.state.outreason}
                                  onChange={(e) => this.onchangeReason(e)} required id="select1" style={{ marginTop: '8px' }}>
                                  <option value="select">Select Your Reason</option>
                                  <option value="Query Raised">Query Raised</option>
                                  <option value=" Re-Query Raised"> Re-Query Raised</option>
                                  <option value="Hold ">Hold </option>
                                  <option value="Completed">Completed</option>
                                  <option value="Other">Others</option>
                                </select>
                                {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                              </div>
                              <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button type="button" className="btn btn-primary" disabled={this.state.isLoading}
                                  onClick={this.outimeGet} style={{ width: '76px', fontSize: '17px' }}>
                                  {this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}
                                </button>
                                <button type="button" className="btn btn-outline" onClick={this.BacktoFile}
                                  style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}>
                                  Back To File
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* OTHER REASON MODAL */}
                        <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                          <div className="modal-dialog">
                            <div className="modal-content" style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}>
                              <h5 style={{ marginTop: "31px", textAlign: "center" }}>
                                Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")}
                              </h5>
                              <div className="modal-body" style={{ padding: "30px 23px 29px 24px" }}>
                                <div className="form-group" style={{ width: "98%", margin: "auto" }}>
                                  <textarea className="form-control" placeholder="Type Your Reason" name="outreason" onChange={this.onchange} />
                                  {selectVal ? <p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>Please Select Your Reason </p> : null}
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={() => this.outimeGet()}
                                  style={{ width: "76px", fontSize: "17px" }} disabled={this.state.isLoading}>
                                  {this.state.isLoading ? <i className="fa fa-spinner fa-spin"></i> : "OK"}
                                </button>
                                <button type="button" className="btn btn-outline" onClick={() => this.previousPop()}
                                  style={{ width: "76px", fontSize: "17px", border: "1px solid black" }}>
                                  Back
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-body">
                          {this.state.autoAssign && this.state.autoAssign.find(
                            (data: any) => data.module_name === "Auto Assign" && data.status) ?
                            <>
                              {this.state.isFileRefresh &&
                                <>
                                  {/* ── GRADE SUMMARY PANEL at the TOP ── */}
                                  {this.state.pageDynamic.map((page: any, index: any) => {
                                    if (page.page_name === "File Grade Summary In Queue" && page.status == true) {
                                      return (
                                        <div className={"grade-summary-container"} style={{ marginTop: "20px", marginBottom: "10px" }}>
                                          {this.renderGradeSummary()}
                                        </div>
                                      );
                                    }
                                  })}

                                  <div className="card-body">
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                      <h5 className="file-status-header">
                                        A+ Grade Files
                                        {term && (
                                          <span style={{ marginLeft: 8, fontSize: "13px", color: filteredAPlusFile.length > 0 ? "#4e73df" : "#999" }}>
                                            ({filteredAPlusFile.length} match{filteredAPlusFile.length !== 1 ? "es" : ""})
                                          </span>
                                        )}
                                      </h5>


                                      <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px 0" }}>
                                        <div style={{ position: "relative", flex: 1, maxWidth: "300px" }}>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search across all tables..."
                                            value={this.state.commonSearch}
                                            onChange={(e) => this.setState({ commonSearch: e.target.value })}
                                            style={{ paddingRight: "1px" }}
                                          />
                                          {this.state.commonSearch && (
                                            <span onClick={() => this.setState({ commonSearch: "" })}
                                              style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#999", fontSize: "16px", lineHeight: 1 }}
                                              title="Clear search">✕</span>
                                          )}
                                        </div>
                                        {matchInfo.length > 0 && (
                                          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                            {matchInfo.map((m, i) => (
                                              <span key={i} style={{ background: "#4e73df", color: "#fff", borderRadius: "12px", padding: "2px 10px", fontSize: "12px", whiteSpace: "nowrap" }}>
                                                {m.label}: {m.count}
                                              </span>
                                            ))}
                                          </div>
                                        )}
                                        {term && matchInfo.length === 0 && (
                                          <span style={{ color: "#e74c3c", fontSize: "13px" }}>No matches found in any table.</span>
                                        )}
                                      </div>
                                      {isExpressEnableToUser && (<Queuefilesexceldownload data={this.state.getfileforDownload ?? []} />)}
                                    </div>
                                    <ReactFlexyTable data={filteredAPlusFile} columns={columns} sortable globalSearch />
                                  </div>

                                  <div className="card-body">
                                    <h5 className="file-status-header">
                                      Waiting Files 20+ Mins (A1, A, B, C Grade Files)
                                      {term && (
                                        <span style={{ marginLeft: 8, fontSize: "13px", color: filteredWaitingData.length > 0 ? "#4e73df" : "#999" }}>
                                          ({filteredWaitingData.length} match{filteredWaitingData.length !== 1 ? "es" : ""})
                                        </span>
                                      )}
                                    </h5>
                                    <ReactFlexyTable data={filteredWaitingData} columns={columns} sortable globalSearch />
                                  </div>

                                  <div className="card-body">
                                    <h5 className="file-status-header">
                                      New Files (A1, A, B, C Grade Files)
                                      {term && (
                                        <span style={{ marginLeft: 8, fontSize: "13px", color: filteredLoginData.length > 0 ? "#4e73df" : "#999" }}>
                                          ({filteredLoginData.length} match{filteredLoginData.length !== 1 ? "es" : ""})
                                        </span>
                                      )}
                                    </h5>
                                    <ReactFlexyTable data={filteredLoginData} columns={columns} sortable globalSearch />
                                  </div>

                                  <div className="card-body">
                                    <h5 className="file-status-header">
                                      Emergent Files
                                      {term && (
                                        <span style={{ marginLeft: 8, fontSize: "13px", color: filteredEmergentFile.length > 0 ? "#4e73df" : "#999" }}>
                                          ({filteredEmergentFile.length} match{filteredEmergentFile.length !== 1 ? "es" : ""})
                                        </span>
                                      )}
                                    </h5>
                                    <ReactFlexyTable data={filteredEmergentFile} columns={emergentColumns} sortable globalSearch />
                                  </div>
                                </>
                              }
                            </> :
                            <>
                              {this.state.isFileRefresh && (
                                <div className="card-body">
                                  <ReactFlexyTable data={filteredData} columns={columns} sortable globalSearch />
                                </div>
                              )}
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AssignBankUser
          fileToBeAssigned={this.state.fileToBeAssigned}
          getFiles={() => this.props.history.push("/assigned-file/")}
          assignedFrom={"unassign"}
        />
        <FileSearchModal
          fileStatus={0}
          searchFileCallback={(data) => this.fileSearch(data)}
        />
      </section>
    );
  }
}

export default ManageUnassignedFile;